import React from "react";
import { Card } from "react-bootstrap";
import { injectLinks } from "../../pages/Faq/injectLinks";
import { isEn } from "../../app/i18n/i18n";
import "../../pages/Faq/faq.css";

export const PublicFaqBody = ({ categories, faq }) => (
  <section>
    {categories.map((category, index) => (
      <PublicFaqCard key={index} category={category} faq={faq} />
    ))}
  </section>
);

const PublicFaqCard = ({ category, faq }) => {
  const faqItems = faq.filter((item) => item.category_en === category || item.category_ja === category);
  const categoryId = category.replace(/ /g, "_");

  return (
    <Card className="page border-grey shadow-lg mb-4" id={categoryId}>
      <Card.Header className="border-0 bg-light">
        <h3 className="font-weight-lighter mb-0 text-dark">{category}</h3>
      </Card.Header>

      <Card.Body className="px-4 py-3">
        {faqItems.map((faqItem, index) => (
          <PublicFaqQuestion key={index} {...faqItem} />
        ))}
      </Card.Body>
    </Card>
  );
};

const PublicFaqQuestion = ({ question_en, question_ja, answer_en, answer_ja }) => (
  <div className="mb-4">
    <h5 className="font-weight-bold text-dark mb-2">
      {isEn() ? question_en : question_ja}
    </h5>
    <p className="whitespace-pre-line text-muted">
      {injectLinks(isEn() ? answer_en : answer_ja)}
    </p>
  </div>
);